<template>
    <section class="section">
        <div class="title has-text-centered">Tack för att du rapporterade in resultatet!</div>
    </section>
</template>

<script>
export default {
  name: "Confirmation",
  methods: {}
};
</script>

<style lang="scss">
</style>
